"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OUTLINED_ICON_TEST_ID = exports.FILLED_ICON_TEST_ID = void 0;
const OUTLINED_ICON_TEST_ID = exports.OUTLINED_ICON_TEST_ID = 'HeartIcon';
const FILLED_ICON_TEST_ID = exports.FILLED_ICON_TEST_ID = 'HeartFilledIcon';
